import React from 'react'
import { capitalize } from 'lodash-es'

import { filterSelect } from 'syft-acp-util/components/FilterForm/FilterSelect'

import { DataAppealOutcomeDropdownProps as Props } from './DataAppealOutcomeDropdown.types'

const SelectOutcome = filterSelect(
  [
    {
      id: 'in_progress',
      label: 'In progress',
    },
    {
      id: 'accepted',
      label: 'Accepted',
    },
    {
      id: 'declined',
      label: 'Declined',
    },
  ],
  'New',
  'id',
  false
)

const formatOutcomeDisplay = (outcome: string | null) => 
  outcome ? capitalize(outcome.replace(/_/g, ' ')) : 'n/a'

const DataAppealOutcomeDropdown = ({ disabled = false, editable = false, data, onChange }: Props) => {
  // Prevent changing from in_progress back to "New" (null)
  const allowAny = data.outcome !== 'in_progress'
  
  if (editable) return <SelectOutcome value={data.outcome} onChange={onChange} allowAny={allowAny} disabled={disabled} />
  return <div className="plain-text">{formatOutcomeDisplay(data.outcome)}</div>
}

export default DataAppealOutcomeDropdown
